/**
 * Nicha — grilles produit : collections + recommandations fiche produit
 * N'altère pas le bloc produit principal (Globo, prix principal, etc.)
 * BUILD: 2026-06-18-jacquemus-grid-v7
 */
(function () {
  'use strict';

  const BUILD = '2026-06-18-jacquemus-grid-v7';
  const BADGE_ATTR = 'data-nicha-collection-badge';
  const vendorCache = new Map();

  const TITLE_SIZE = { mobile: '1.125rem', desktop: '1.375rem' };
  const PRICE_SIZE = { mobile: '1.125rem', desktop: '1.375rem' };

  const GRID_CARD_SELECTOR =
    'body.nicha-collection-page .collection .card-wrapper, body.nicha-collection-page .collection .product-card-wrapper, body.nicha-product-page product-recommendations.product-recommendations .card-wrapper, body.nicha-product-page .product-recommendations .card-wrapper';

  const GRID_TYPO_HEADING_SELECTOR =
    'body.nicha-collection-page .collection .card-wrapper .card__heading, body.nicha-collection-page .collection .card-wrapper .card__heading a, body.nicha-product-page product-recommendations.product-recommendations .card-wrapper .card__heading, body.nicha-product-page product-recommendations.product-recommendations .card-wrapper .card__heading a, body.nicha-product-page .product-recommendations .card-wrapper .card__heading, body.nicha-product-page .product-recommendations .card-wrapper .card__heading a';

  const GRID_TYPO_PRICE_SELECTOR =
    'body.nicha-collection-page .collection .card-wrapper .card__information .price, body.nicha-collection-page .collection .card-wrapper .card__information .price-item, body.nicha-collection-page .collection .card-wrapper .card-information .price-item--regular, body.nicha-product-page product-recommendations.product-recommendations .card-wrapper .card__information .price, body.nicha-product-page product-recommendations.product-recommendations .card-wrapper .card__information .price-item, body.nicha-product-page product-recommendations.product-recommendations .card-wrapper .card-information .price-item--regular, body.nicha-product-page .product-recommendations .card-wrapper .card__information .price-item, body.nicha-product-page .product-recommendations .card-wrapper .card-information .price-item--regular';

  const isCollectionPage = () => {
    const path = (window.location.pathname || '').toLowerCase();
    return /\/collections\/[^/]+/.test(path) && !/\/products\//.test(path);
  };

  const isProductPage = () => {
    const path = (window.location.pathname || '').toLowerCase();
    return /\/products\/[^/]+/.test(path);
  };

  const isEnglishLocale = () => {
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase();
    return locale === 'en' || locale.startsWith('en-');
  };

  const getCustomizableLabel = () => (isEnglishLocale() ? 'CUSTOMIZABLE' : 'PERSONNALISABLE');

  const getReadyToGoLabel = () => (isEnglishLocale() ? 'READY TO GO' : 'PRÊT À PARTIR');

  const normalizeText = (text) =>
    (text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const isReadyToGoHandle = (handle) => {
    const h = normalizeText(handle);
    return h.includes('ready-to-go') || h.includes('pret-a-partir');
  };

  const isReadyToGoVendor = (vendor) => {
    const v = normalizeText(vendor);
    return (v.includes('pret') && v.includes('partir')) || (v.includes('ready') && v.includes('go'));
  };

  const isReadyToGoCollection = (handle) => {
    const h = normalizeText(handle);
    if (h.includes('pret-a-partir-homme') || h.includes('ready-to-go-menswear')) return false;
    if (h.includes('pret-a-partir')) return true;
    return h.includes('ready-to-go');
  };

  const getCollectionHandle = () => {
    const match = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const getProductHandleFromCard = (card) => {
    const link =
      card.querySelector('.card__heading a[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    const match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const getShopifyRoot = () => {
    const root = window.Shopify?.routes?.root;
    return root ? (root.endsWith('/') ? root : `${root}/`) : '/';
  };

  const fetchProductVendor = async (handle) => {
    if (!handle) return '';
    if (vendorCache.has(handle)) return vendorCache.get(handle);
    try {
      const response = await fetch(`${getShopifyRoot()}products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) return '';
      const product = await response.json();
      const vendor = product.vendor || '';
      vendorCache.set(handle, vendor);
      return vendor;
    } catch {
      return '';
    }
  };

  const fetchVendorMap = async (collectionHandle) => {
    if (!collectionHandle) return new Map();
    const map = new Map();
    let page = 1;
    let hasMore = true;

    while (hasMore && page <= 4) {
      const url = `${getShopifyRoot()}collections/${encodeURIComponent(collectionHandle)}/products.json?limit=250&page=${page}`;
      try {
        const response = await fetch(url);
        if (!response.ok) break;
        const data = await response.json();
        const products = data.products || [];
        products.forEach((product) => {
          map.set(product.handle, product.vendor || '');
          vendorCache.set(product.handle, product.vendor || '');
        });
        hasMore = products.length === 250;
        page += 1;
      } catch {
        break;
      }
    }
    return map;
  };

  const readVendorFromCard = (card) => {
    const caption = card.querySelector('.card-information .caption-with-letter-spacing');
    return (caption?.textContent || '').trim();
  };

  const getBadgeLabel = (handle, vendorMap, collectionHandle, card, vendorOverride) => {
    if (isReadyToGoCollection(collectionHandle) || isReadyToGoHandle(handle)) {
      return getReadyToGoLabel();
    }
    const vendor =
      vendorOverride ||
      vendorMap.get(handle) ||
      vendorCache.get(handle) ||
      readVendorFromCard(card) ||
      '';
    return isReadyToGoVendor(vendor) ? getReadyToGoLabel() : getCustomizableLabel();
  };

  const hideVendorCaptions = (card) => {
    card
      .querySelectorAll('.card-information .caption-with-letter-spacing, .card__vendor')
      .forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
      });
  };

  const applyTypography = () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const titleSize = isMobile ? TITLE_SIZE.mobile : TITLE_SIZE.desktop;
    const priceSize = isMobile ? PRICE_SIZE.mobile : PRICE_SIZE.desktop;
    const font = 'var(--font-body-family, "Helvetica Neue", Arial, sans-serif)';

    document.querySelectorAll(GRID_TYPO_HEADING_SELECTOR).forEach((el) => {
      el.style.setProperty('font-family', font, 'important');
      el.style.setProperty('font-size', titleSize, 'important');
      el.style.setProperty('font-weight', '400', 'important');
      el.style.setProperty('line-height', '1.35', 'important');
      el.style.setProperty('color', '#1a1a1a', 'important');
      el.style.setProperty('text-align', 'left', 'important');
    });

    document.querySelectorAll(GRID_TYPO_PRICE_SELECTOR).forEach((el) => {
      el.style.setProperty('font-family', font, 'important');
      el.style.setProperty('font-size', priceSize, 'important');
      el.style.setProperty('font-weight', '400', 'important');
      el.style.setProperty('color', '#767676', 'important');
      el.style.setProperty('text-align', 'left', 'important');
    });
  };

  const ensureBadge = (card, label) => {
    if (!card) return;

    const anchor = card.querySelector('.card__inner.ratio, .card__inner, .card__media');
    if (!anchor) return;

    let badge = anchor.querySelector(':scope > .nicha-collection-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'nicha-collection-badge';
      anchor.insertBefore(badge, anchor.firstChild);
    }
    badge.textContent = label;
    badge.style.setProperty('color', '#ffffff', 'important');
    badge.style.setProperty('text-shadow', '0 1px 3px rgba(0, 0, 0, 0.35)', 'important');
    badge.style.setProperty('font-size', window.matchMedia('(min-width: 750px)').matches ? '1rem' : '0.9375rem', 'important');
    card.setAttribute(BADGE_ATTR, '1');
    hideVendorCaptions(card);
  };

  const applyGridEnhancements = async (vendorMap, collectionHandle) => {
    const wrappers = document.querySelectorAll(GRID_CARD_SELECTOR);
    if (!wrappers.length) return;

    await Promise.all(
      Array.from(wrappers).map(async (wrapper) => {
        const card = wrapper.querySelector('.card') || wrapper;
        const handle = getProductHandleFromCard(card);
        if (!handle) return;

        let vendor = vendorMap.get(handle) || vendorCache.get(handle) || readVendorFromCard(card);
        if (!vendor && isProductPage()) {
          vendor = await fetchProductVendor(handle);
        }

        ensureBadge(card, getBadgeLabel(handle, vendorMap, collectionHandle, card, vendor));
        hideVendorCaptions(card);
      })
    );

    applyTypography();
    if (window.NichaPriceFormat?.refresh) window.NichaPriceFormat.refresh();
  };

  const observeGrid = (vendorMap, collectionHandle, roots) => {
    roots.forEach((root) => {
      if (root.dataset.nichaGridObserver === 'true') return;
      root.dataset.nichaGridObserver = 'true';

      let scheduled = null;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = setTimeout(() => {
          scheduled = null;
          applyGridEnhancements(vendorMap, collectionHandle).catch(() => {});
        }, 120);
      });
      observer.observe(root, { childList: true, subtree: true });
    });
  };

  const initCollection = async () => {
    if (!isCollectionPage()) return;

    document.body.classList.add('nicha-collection-page');

    const collectionHandle = getCollectionHandle();
    const vendorMap = await fetchVendorMap(collectionHandle);

    await applyGridEnhancements(vendorMap, collectionHandle);
    [400, 1200, 2500, 4000].forEach((delay) => {
      setTimeout(() => applyGridEnhancements(vendorMap, collectionHandle).catch(() => {}), delay);
    });

    observeGrid(vendorMap, collectionHandle, [document.querySelector('.collection')].filter(Boolean));
  };

  const initProductRecommendations = async () => {
    if (!isProductPage()) return;

    document.body.classList.add('nicha-product-page');

    const vendorMap = new Map();
    const collectionHandle = '';

    const run = () => applyGridEnhancements(vendorMap, collectionHandle);

    await run();
    [400, 1200, 2500, 4000, 6000].forEach((delay) => setTimeout(() => run().catch(() => {}), delay));

    const roots = Array.from(
      document.querySelectorAll('product-recommendations.product-recommendations, .product-recommendations')
    );
    observeGrid(vendorMap, collectionHandle, roots);

    if (!window.__NICHA_COLLECTION_TYPO_RESIZE__) {
      window.__NICHA_COLLECTION_TYPO_RESIZE__ = true;
      window.addEventListener('resize', () => setTimeout(applyTypography, 100));
    }
  };

  const init = async () => {
    try {
      if (isCollectionPage()) await initCollection();
      if (isProductPage()) await initProductRecommendations();
    } catch {
      /* noop */
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init().catch(() => {});
    });
  } else {
    init().catch(() => {});
  }

  document.addEventListener('shopify:section:load', () => {
    init().catch(() => {});
  });

  window.NichaCollectionGrid = { build: BUILD, refresh: init };
})();
